import { NgModule } from '@angular/core';
import { LIB_CommonModule } from 'pbc.angular';
import { DeleteZeitArtCommandService } from '.';

@NgModule({
  imports: [
    LIB_CommonModule,
  ],
  providers: [DeleteZeitArtCommandService],
  exports: []
})
export class DeleteZeitArtCommandServiceModule { }
